import React from 'react';
import PropTypes from 'prop-types';
import TypographyDraft from '../TypographyDraft';
import classNames from 'classnames';
import injectSheet from 'react-jss';

function SectionTitle({ classes, title, className, style }) {
  return (
    <TypographyDraft
      component="h2"
      className={classNames(classes.root, className)}
      style={style}
      data={title}
    />
  );
}

SectionTitle.propTypes = {
  classes: PropTypes.object.isRequired,
  style: PropTypes.object.isRequired,
  title: PropTypes.object,
  className: PropTypes.string,
};

SectionTitle.defaultProps = {
  className: null,
  styles: null,
  title: {},
};

const stylesheet = theme => ({
  root: {
    textAlign: 'center',
    fontSize: 28,
    marginBottom: 5 * theme.spacing.unit,
  },
});

export default injectSheet(stylesheet)(SectionTitle);



// WEBPACK FOOTER //
// ./src/site-render/src/Section/SectionTitle.js